import {dataService, uploadService} from "base/config";

const ApiService = {
    get(url, headers = {}, includeCredentials = false, followRedirection = true) {
        return dataService.get(url, headers, includeCredentials, followRedirection);
    },

    post(url, data, contentType, headers = {}) {
        return dataService.post(url, data, contentType, headers);
    },

    put(url, data, headers = {}) {
        return dataService.put(url, data, headers);
    },

    patch(url, data, bulk = false, headers = {}) {
        return dataService.patch(
            url,
            data,
            bulk ? {"X-BULK-OPERATION": true, ...headers} : {...headers}
        );
    },

    delete(url, headers = {}) {
        return dataService.del(url, headers);
    },

    upload(file, url, headers = {}, ...rest) {
        return uploadService.upload(
            file,
            url,
            {
                ...headers,
                "Content-Disposition": "attachment; filename=" + file.name,
            },
            ...rest
        );
    },
};

export default ApiService;
